<template>
  <div class="fddform-input fddform-input-symbol">
    <label class="use-minus" @click="decrease"></label>
    <input
      ref="input"
      type="text"
      class="input"
      :value="value"
      :disabled="disabled"
      @blur="handleBlur"
      @keydown.enter="handleEnter"
    />
    <label class="use-add" @click="increase"></label>
  </div>
</template>
<script>
  export default {
    name: 'FddInputNumber',
    props: {
      disabled: {
        type: Boolean,
        default: false
      },
      step: {
        type: Number,
        default: 1
      },
      max: {
        type: Number,
        default: Infinity
      },
      min: {
        type: Number,
        default: -Infinity
      },
      value: [Number, String]
    },
    data() {
      return {
        timer: null,
        num: 0
      }
    },
    computed: {
      mode: {
        set(value) {
          this.$emit('input', value)
        },
        get() {
          return this.value
        }
      },
      inputNumberDisabled() {
        return this.disabled
      },
      minDisabled() {
        return this.value - this.step >= this.min
      },
      maxDisabled() {
        return this.value + this.step <= this.max
      }
    },
    mounted() {
      this.num = this.value
    },
    methods: {
      handleBlur(e) {
        if (!isNaN(e.target.value)) {
          this.setCurrentValue(parseInt(e.target.value, 10))
        }
        e.target.value = this.value
      },
      handleEnter(e) {
        this.handleBlur(e)
      },
      decrease() {
        if (!this.inputNumberDisabled && this.minDisabled) {
          clearTimeout(this.timer)
          this.timer = setTimeout(() => {
            this.value -= this.step
            this.setCurrentValue(this.value)
          }, 100)
        }
      },
      increase() {
        if (!this.inputNumberDisabled && this.maxDisabled) {
          clearTimeout(this.timer)
          this.timer = setTimeout(() => {
            this.value += this.step
            this.setCurrentValue(this.value)
          }, 100)
        }
      },
      setCurrentValue(value) {
        let oldValue = this.num
        this.value = parseInt(value > this.max ? this.max : value < this.min ? this.min : value, 10)
        if (oldValue === this.value) {
          return false
        }
        this.num = value
        this.$emit('input', this.value)
        this.$emit('change', this.value)
        return true
      }
    }
  }
</script>
